<template>
    <div class="c-calendar-components">
        <Loader v-if="isLoading"/>
        <FullCalendar
            defaultView = 'dayGridMonth'
            ref = "attendableVueCalendar"
            :datesRender = "datesRender"
            :default-date="defaultDate"
            :displayEventTime = false
            :events = "events"
            :eventRender = "eventRender"
            :event-limit = "5"
            :fixed-week-count="false"
            :show-non-current-dates="true"
            :header = "calendarHeader"
            :plugins = "calendarPlugins"
            :viewSkeletonRender="viewSkeletonRender"
            @windowResize = "windowResize"
        />
    </div>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import listPlugin from '@fullcalendar/list'
    import moment from 'moment'
    import Loader from "./Loader"

    export default {
        name: 'Calendar',
        props: {
            firstInstanceDate: {
                type: [String, Date],
                default: null
            },
            lastInstanceDate: {
                type: [String, Date],
                default: null
            }
        },
        components: {
            FullCalendar,
            Loader
        },
        data() {
            return {
                allInstances: [],
                calendarHeader: {
                    left: '',
                    center: 'title',
                    right: 'prev next'
                },
                calendarPlugins: [ dayGridPlugin, listPlugin ],
                defaultDate: moment(this.firstInstanceDate).format('YYYY-MM-DD'),
                events: [],
                isLoading: true
            }
        },
        mounted() {
            this.setView();
        },
        methods: {
            beforeRequest() {
                axios.interceptors.request.use((config) => {
                    this.events = []
                    this.isLoading = true
                    return config
                });
            },
            datesRender(info) {

                // Loads the instances for the month currently in view
                let currentDate = moment(info.view.currentStart),
                startDate = currentDate.format('YYYY-MM-DD'),
                currentMonth = currentDate.format('YYYY-MM');

                // If the current month is a key inside the allInstances array, then load that, Otherwise, fetch the instances via ajax
                if (currentMonth in this.allInstances) {
                    this.events = this.allInstances[currentMonth];
                } else {
                    // Otherwise, fetch the instances
                    this.events = this.fetchInstances(startDate);

                }
                this.toggleDateNavigationButtonState()
            },
            eventRender(info) {
                // Render the title as HTML
                let title = info.el.querySelectorAll('.fc-title, .fc-list-item-title');

                if (title.length > 0) {
                    title[0].innerHTML = title[0].innerText;
                }
            },
            fetchInstances(startDate) {

                let currentMonth = moment(startDate).format('YYYY-MM');

                this.beforeRequest()
                axios.get(window.ajax.url, {
                    params: {
                        action: 'basethemeCalendarRequest',
                        selectedDate: startDate
                    }
                })
                .then((response) => {
                    let responseInstances = response.data.instances,
                        instance,
                        instances = [];

                    for (let i = 0; i < responseInstances.length; i++) {
                        instance = responseInstances[i];
                        instances.push({
                            title: instance.content,
                            start: instance.wp.post_date,
                        });
                    }

                    // Push our instances to the allInstances property, so we can use those next time rather than make another ajax call
                    this.allInstances[currentMonth] = instances;

                    // Assign the instances to our proerty as that is passed to the calendar
                    this.events = instances;
                    this.isLoading = false

                })
                .catch(function (error) {
                    console.error(error)
                })
            },
            setView() {
                let calendarApi = this.$refs.attendableVueCalendar.getApi();
                // If the screen is handheld
                if (this.$screen.handheld) {
                    return calendarApi.changeView('listMonth');
                }
                return calendarApi.changeView('dayGridMonth');
            },
            toggleDateNavigationButtonState() {
                let calendarApi = this.$refs.attendableVueCalendar.getApi()

                let currentDate = moment(calendarApi.view.currentStart).format('YYYYMM'),
                    firstInstanceDate = moment(this.firstInstanceDate).format('YYYYMM'),
                    lastInstanceDate = moment(this.lastInstanceDate).format('YYYYMM')

                if (currentDate === firstInstanceDate) {
                    document.querySelector('.fc-prev-button').setAttribute('disabled', 'disabled');
                    document.querySelector('.fc-next-button').removeAttribute('disabled');
                } else if (currentDate === lastInstanceDate) {
                    document.querySelector('.fc-next-button').setAttribute('disabled', 'disabled');
                    document.querySelector('.fc-prev-button').removeAttribute('disabled');
                }
            },
            viewSkeletonRender(info) {
                this.toggleDateNavigationButtonState()
            },
            windowResize() {
                this.setView();
            }
        },
    }
</script>

<style lang='scss'>
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/list/main.css';
</style>
